export class MeetingScheduler {
    title: string;
    start: Date;
    end: Date;
    backgroundColor: string;
    borderColor: string;
    foreColor: string;
    icon: string;
    allDay: boolean;
    editable: boolean;
    data: MeetingSchedulerData;
    dropAccept: string;
    textColor: string;
    agendaPosted: boolean;
    minutesPosted: boolean;
    videoPosted: boolean;
    agendaPacketEnabled: boolean;
    minutesPacketEnabled: boolean;

    constructor() {
        this.title = '';
        this.start = new Date();
        this.end = new Date();
        this.backgroundColor = '';
        this.borderColor = '';
        this.foreColor = '';
        this.icon = 'event';
        this.allDay = false;
        this.editable = false;
        this.data = new MeetingSchedulerData();
        this.dropAccept = '.fc-content-skeleton';
        this.textColor = '';
        this.agendaPosted = false;
        this.minutesPosted = false;
        this.videoPosted = false;
    }
}

export class MeetingSchedulerData {
    id: number;
    recurringId: number;
    location: string;
    actualStartDate: string;
    actualEndDate: string;
    startTime: string;
    endTime: string;
    recurringType: string;
    isAdjourned: boolean;
    occuranceType: number;

    startDate: string;

    enddDate: string;
    constructor() {
        this.id = 0;
        this.recurringId = 0;
        this.location = '';
        this.actualEndDate = '';
        this.actualStartDate = '';
        this.startDate = '';
        this.enddDate = '';
        this.startTime = '';
        this.endTime = '';
        this.recurringType = '';
        this.isAdjourned = true;
        this.occuranceType = 0;
    }

}

export class MeetingDragDropModel {
    meetingId: number;
    recurringId: number;
    occuranceType: number;
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
    actualStartDate: string;
    actualEndDate: string;
    constructor() {
        this.meetingId = 0;
        this.recurringId = 0;
        this.occuranceType = 0;
        this.startDate = '';
        this.endDate = '';
        this.actualEndDate = '';
        this.actualStartDate = '';
    }
}
